import { Direction } from '@angular/cdk/bidi';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  METER_SHORT,
  PLATFORM,
  STATION_CODE,
  WALKING_DIRECTIONS_LIST_LABEL,
  WALKING_TO,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { Coordinate } from 'src/app/modules/route-planner/interfaces/location/coordinate.interface';
import { SourceDestinationForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/source-destination-form';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';

@Component({
    selector: 'app-detailed-result-route-pedestrian',
    templateUrl: './detailed-result-route-pedestrian.component.html',
    styleUrls: ['./detailed-result-route-pedestrian.component.scss'],
    standalone: false
})
export class DetailedResultRoutePedestrianComponent implements OnInit {
  @Input() formValues: SourceDestinationForm;
  @Input() section: Section;
  @Input() index: number;
  @Input() length: number;
  @Input() leg: Address | null
  @Input() isNextSectionCar: boolean = false
  @Input() isWalkingToStop: boolean = false
  @Output() focusLocationEvent: EventEmitter<Coordinate> = new EventEmitter<Coordinate>();

  direction: Direction;

  walkingToText: string
  calculatedDurationText: string
  distanceUnitShortText: string
  stationCodeText: string
  platformText: string
  /** Localized accessible name for the turn-by-turn instructions list. */
  walkingDirectionsListLabel: string

  constructor(
    public readonly routePlanningService: RoutePlanningService,
    public readonly languageService: LanguageService
  ) {

  }

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
      this.calcSectionDuration()
      this.walkingToText = WALKING_TO[language.language]
      this.distanceUnitShortText = METER_SHORT[language.language]
      this.stationCodeText = STATION_CODE[language.language]
      this.walkingDirectionsListLabel = WALKING_DIRECTIONS_LIST_LABEL[language.language]
      this.platformText = PLATFORM[language.language]
    })
  }

  calcSectionDuration() {
    this.calculatedDurationText = this.routePlanningService.calcSectionDuration(this.section.travelSummary.duration)
  }

  calcSectionDistance() {
    return this.routePlanningService.calcSectionDistance(this.section.travelSummary.length)
  }

  getWalkDestinationName() {
    if (this.section.arrival.place.name) {
      return this.section.arrival.place.name
    } else if (this.leg && this.isNextSectionCar) {
      return this.leg.addressDetails.label
    } else if (this.formValues.stop && this.isWalkingToStop) {
      return this.formValues.stop.addressDetails.label
    } else {
      return this.formValues.destination.addressDetails.label
    }
  }

}
